import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import { computed } from 'vue';
export default {
  name: 'KpiValueCompareInput',
  props: {
    mode: {
      type: String,
      default: '',
      validator: value => ['', 'input', 'search'].includes(value)
    }
  },
  setup(props) {
    const values = computed(() => {
      const values = [];
      if (props.mode === 'search') {
        values.push({
          value: 0,
          label: '[所有比较方式]'
        });
      }
      values.push(...[{
        value: 0,
        label: '未设置'
      }, {
        value: 5,
        label: '>'
      }, {
        value: 6,
        label: '>='
      }, {
        value: 7,
        label: '<'
      }, {
        value: 8,
        label: '<='
      }, {
        value: 3,
        label: '='
      },
      // { value: 4, label: '<>' },
      {
        value: 2,
        label: '非量化指标'
      }, {
        value: 1,
        label: '不使用指标值'
      }]);
      return values;
    });
    return {
      values
    };
  }
};